module.exports = __webpack_public_path__ + "img/Companycultrue-create.62509868.png";